// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2agPR","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2d0rD"};